
import { Site } from "models/Site";
import { Region } from "models/Region";
import type { Moment } from "moment";
import { Model } from "react3l-common";
import { Field, MomentField } from "react3l-decorators";

export class Project extends Model {
  @Field(Number)
  public id?: number;

  @Field(String)
  public code?: string;

  @Field(String)
  public biddingPackageCode?: string;

  @Field(String)
  public name?: string;

  @Field(String)
  public address?: string;

  @Field(Number)
  public projectTypeId?: number;

  @Field(Number)
  public projectGroupId?: number;

  @Field(Number)
  public projectStatusId?: number;

  @Field(Number)
  public organizationId?: number;

  @Field(Number)
  public areaId?: number;

  @Field(Number)
  public landBankId?: number;

  @Field(Number)
  public regionId?: number;

  @MomentField()
  public startedAt?: Moment;

  @MomentField()
  public endedAt?: Moment;
  @Field(String)
  public investorName?: string;

  @Field(String)
  public note?: string;

  @Field(Boolean)
  public used?: boolean;

  @MomentField()
  public createdAt?: Moment;

  @MomentField()
  public updatedAt?: Moment;

  @MomentField()
  public deletedAt?: Moment;
  @Field(String)
  public rowId?: string;

  public region?: Region;
  public site?: Site;
}
